import React from 'react';
import { Formik, Form, Field} from 'formik';
import * as Yup from 'yup'
import { Box,  Typography, Button} from '@mui/material';
import '../../css/App.css';

function NhsNumber(props) {

const initialValues={nhsNumber:undefined}

const validationSchema = Yup.object({
    nhsNumber: Yup.string().required("Please enter the NHS number"),
  })

  const onSubmit=(values)=>
    {
    let nhsNumberNoSpace=values.nhsNumber.replaceAll(" ","")
    //needs regex match to check not non numeric elements.

    }

    return ( 
        <Box>
        <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
        >

        <Form>
            
          <Typography variant='span' id="nhsNumberHolder">
            <Typography sx={{ mr: 2 }} component='label' htmlFor='NhsNumber'>NHS number
            </Typography>
            <Field type="text" name="nhsNumber" required /> </Typography>

            <Button sx={{ m: 1 }} variant='contained' type='submit'>Find Patient</Button>
        </Form>

        </Formik>
</Box>
     );
}

export default NhsNumber;

